// extracted by mini-css-extract-plugin
export default {"section":"Address__section___b3kXu","heading":"Address__heading___GRZSt","sections":"Address__sections___3JscL","details":"Address__details___CeM1q"};